/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PartnerIntent } from "./PartnerIntent";

export type GetVisitOptionsForAFlowUserProgressionFlowsFlowNameVisitOptionsGetParams =
  {
    clinic_request_id?: string | null;
    user_progression_id?: string | null;
    partner_intent?: PartnerIntent | null;
  };
